<div>
  <nav class="navbar ">
    <div class="container position-rel">
     <img src="\assets\img\header1.png" alt="logo" class="wid-70">
          <h4 class="color-red-10">{{inviNo}}</h4>
    </div>
  </nav>
</div>
<!--HON-INV-2102-->
